import {React, Component, _, Modal, Header, Body} from 'utils';
import {Creators} from 'model'
import PropTypes from 'prop-types';
import './filters.less';

export default class Filters extends Component {

	openModal = (event) =>
	{
		let name = $(event.target).closest('button').data('name');
		Creators.openFilterModal(name);
	};

	generateFilters = (name, items) =>
	{
		let itemElements = items.map((item, i) =>
		{
			let selectedClass = (item.selected) ? ' selected ' : '';
			let activeClass = (item.active) ? ' active ' : '';
			return (
				<div key={'mi_'+name+i} className={'col-12 filter-item ' + selectedClass + activeClass}
					 onClick={this.props.onFilterClick}
					 data-filter={name} data-name={item.name} data-index={item.index}>
					{item.name}
				</div>
			);
		});

		return (
			<div key={'m_'+name} className="filter-group">
				<div className="row">
					{itemElements}
				</div>
			</div>
		)
	};

	render()
	{
		let {page, query, loading, filters} = this.props;

		let filterButtons = [];
		let filterModals = [];
		let tags = [];

		filters.map((filter, fi)=>
		{
			filterButtons.push(
				<button key={'fb'+fi} onClick={this.openModal} data-name={page+'-'+filter.name} type="submit"
						className="btn btn-lg btn-primary add-filter">
					<span className="d-none d-md-inline">{_('Filter ' + filter.name.toLowerCase())}</span>
					<i className="fa fa-sliders"/>
				</button>
			);

			let showFuncName = 'filter-show-' + page + '-' + filter.name;
			let hideFuncName = 'filter-hide-' + page + '-' + filter.name;

			filterModals.push(
				<Modal key={'fm'+fi} show={showFuncName} hide={hideFuncName} className="filter-modal">
					<Header title={_('Filter by ' + filter.name.toLowerCase())}/>
					<Body>
					<div>
						{this.generateFilters(filter.name, filter.items)}
					</div>
					<div className="sticky-bottom">
						<button className="btn btn-success btn-lg successButton" onClick={this.props.onOkClick}
								data-hide-function-name={hideFuncName}>
							{_('Ok')}
						</button>
					</div>
					</Body>
				</Modal>
			);

			filter.items.map((filterItem)=>
			{
				if (filterItem.active)
				{
					tags.push(
						<span key={filterItem.index} className="filters-active-item" onClick={this.props.onTagClick}
							  data-filter={filter.name} data-name={filterItem.name}
							  data-index={filterItem.index}>{filterItem.name}</span>
					);
				}
			})
		});

		let iconClass = (loading) ? 'fa fa-refresh' : 'fa fa-search';

		return (
			<div className="filters-1">
				<div className="form-group">
					<div className="search-box">
						<input type="text" value={query} onChange={this.props.handleChange}
							   className="form-control form-control-lg"/>
						<i className={iconClass}></i>
					</div>
				</div>

				<div className="sput-filters">
					{filterButtons}
					{filterModals}
					<div className="filters-active row no-gutters">
						{tags}
					</div>
				</div>

			</div>
		);
	}
}

Filters.propTypes = {
	page: PropTypes.string.isRequired,
	filters: PropTypes.array.isRequired,
	query: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired,
	onFilterClick: PropTypes.func.isRequired,
	onOkClick: PropTypes.func.isRequired,
	onTagClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/modules/components/elements/filters.js